// MUI-free copy of Ui-components/Lets-discuss.
import {memo} from 'react';
import type {ReactNode} from 'react';
import parse from 'html-react-parser';
import {cdnImage} from '@/util/cdnImage';
import Container from '@/components/atoms/Container';
import OptimizedImage from '@/components/atoms/OptimizedImage';
import styles from './LetsDiscuss.module.scss';

const Arrow = cdnImage('Blockchain-images/arrow.webp');

export interface LetsDiscussProps {
    heading: ReactNode;
    /** HTML string, parsed. */
    subheading?: string;
    btnLabel: ReactNode;
    openForm?: () => void;
    /** Global classes on the arrow box (e.g. `white-label-sprill dex-aggregator-sprill`). */
    className?: string;
    /**
     * Replaces the old `imageSx`: a (page module) class on the same arrow box. The box's own position
     * (`right: 280px; top: 0`) is not !important, so an override wins only with !important (or higher specificity),
     * the same way every page's imageSx did.
     */
    imageClassName?: string;
}

const LetDiscuss = ({heading, subheading, btnLabel, openForm, className, imageClassName}: LetsDiscussProps) => (
    <Container>
        <div className={`webdev-background margin ${styles.background}`}>
            <div className={`lets-descuss ${styles.letsDescuss}`}>
                <div className={`spectrum-header-wrapper solution-header-wrapper solutions left lets-discuss-inner ${styles.inner}`}>
                    {/* MUITypography with no variant/component: body1 on a <div>. */}
                    <div className={`spectrum-heading color-black  ${styles.heading}`}>{heading}</div>
                    {subheading && <p className="solution-sub-heading color-black data_links">{parse(subheading)}</p>}
                </div>
                <div className={`spriell-image ${className || ''} ${styles.spriell}${imageClassName ? ` ${imageClassName}` : ''}`}>
                    <OptimizedImage src={Arrow} alt="arrow image" priority={false} />
                </div>
                <div className={`header-contact-btn ${styles.contactBtn}`}>
                    <button type="button" className={`nav-button lets-discuss-hover animated-button ${styles.button}`} onClick={openForm}>
                        {btnLabel}
                    </button>
                </div>
            </div>
        </div>
    </Container>
);

export default memo(LetDiscuss);
